import React from "react";
import { FiInfo } from "react-icons/fi";
import { Grid } from "@mui/material";

import useStyles from "./styles";

interface Props {
  errors?: string;
  title: string;
  child?: React.ReactChild;
}

export const UITableHeader = ({ errors, title, child }: Props) => {
  const classes = useStyles({
    hasErrors: errors && errors.length > 0 ? true : false
  })();

  const returnErrors = () => {
    if (errors && errors.length > 0) {
      return (
        <div className={classes.errorWrapper}>
          <FiInfo size={16} className="mr-2" />
          <span className={classes.errors}>{errors}</span>
        </div>
      );
    }

    return null;
  };

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid item md={4} lg={4}>
        <h3 className={classes.headerTitle}>{title}</h3>
        {returnErrors()}
      </Grid>
      <Grid item container md={8} lg={8} justifyContent="flex-end">
        {child}
      </Grid>
    </Grid>
  );
};
